var map = {
	"./4glaza.png": 6229,
	"./Screenshot_20231224_020949.png": 1908,
	"./administration.png": 7122,
	"./babyklub.png": 6825,
	"./bibliotechniycenter.png": 2348,
	"./bibliotekabelinskogo.png": 1939,
	"./centeritcube.png": 4931,
	"./cosmoport.png": 6512,
	"./default.png": 6576,
	"./ekbclub.png": 6626,
	"./englishdrive.png": 1508,
	"./fiit.png": 8453,
	"./hochuvnauku-simple.png": 9285,
	"./hochuvnauku.png": 930,
	"./homecomputer.png": 1619,
	"./icae.png": 9574,
	"./igronaphtic.png": 2153,
	"./iq007.png": 2998,
	"./kantrscrip.png": 4539,
	"./l52.png": 3679,
	"./locman.png": 8245,
	"./molodeznayapolicy-simple.png": 4452,
	"./molodeznayapolicy.png": 3672,
	"./muzeivdv.png": 2830,
	"./npo.png": 3139,
	"./odarennost.png": 5159,
	"./planetariy.png": 2208,
	"./pripev.png": 1314,
	"./schoolbus.png": 8683,
	"./smartschool.png": 9823,
	"./soundcity.png": 4074,
	"./targemgames.png": 649,
	"./zolotoesechenie.png": 4985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1450;